import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/pics/whiteLogo.svg";
import Cookies from "js-cookie";
import { useFetchUserByIdQuery } from "../SettingsDashboard/Hooks";

const Navbar = () => {
	const [dashboardPath, setDashboardPath] = useState("/list-venues");
	const vendorId = localStorage.getItem("vendorId");
	const {
		data: userData,
		isLoading: isFetchingUser,
		error,
	} = useFetchUserByIdQuery(vendorId);
	const navigate = useNavigate();
	const isLoggedIn = !!localStorage.getItem("accessToken");

	const handleLogout = () => {
		// Clear cookies and localStorage data
		Cookies.remove("token", { path: "/" });
		localStorage.removeItem("accessToken");
		localStorage.removeItem("vendorId");
		localStorage.removeItem("invitedBy");
		localStorage.removeItem("checkAdmin");

		// Navigate to login page or refresh to show logged-out state
		navigate("/login");
	};
	useEffect(() => {
		if (userData) {
			// Check if onboarding is completed
			const isOnboardingCompleted =
				userData?.vendor?.onBoardingDetails &&
				Object.keys(userData?.vendor?.onBoardingDetails).length > 0;
			const paymentStatus =
				userData?.vendor?.onBoardingDetails?.paymentStatus || "Unknown";
			// if a team member straight to dashbaord

			const checkInvitedBy = userData?.vendor?.invitedBy;
			if (checkInvitedBy) {
				setDashboardPath("/dashboard");
				return;
			}
			if (isOnboardingCompleted && paymentStatus) {
				// Redirect to dashboard if onboarding is completed & payment is done
				setDashboardPath("/dashboard");
			} else {
				// Redirect to onboarding if onboarding is not completed
				setDashboardPath("/onboarding");
			}
		}
	}, [userData]);
	console.log(userData, "userData");
	return (
		<div className="bg-[#fe4747] flex justify-center w-full py-3 z-[100]">
			<div className="w-[90%] flex justify-between items-center">
				{/* Logo */}
				<div>
					<Link to="/home">
						<img alt="logo" src={logo} />
					</Link>
				</div>

				{/* Links based on login status */}
				<div className="flex items-center gap-8 relative">
					{isLoggedIn ? (
						<>
							<Link to={dashboardPath} className="text-white sm:flex hidden">
								List your Venue
							</Link>
							<button
								onClick={handleLogout}
								className="text-white px-3 py-2 rounded-md"
							>
								Logout
							</button>
						</>
					) : (
						<>
							{/* <Link to="/login" className="text-white">
								Login
							</Link> */}
							<Link
								to="/login"
								className=" text-white"
							>
								Login/Signup
							</Link>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default Navbar;
